import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { FeedbackResponse } from './api.report.model';

export class ReportApi {
  apiUrl = environment.API_URL;
  constructor(
    public readonly httpClient: HttpClient,
    public config: ApiClientConfig
  ) {}

  getFeedbackList(pageNum: number, pageSize: number): Observable<FeedbackResponse> {
    return this.httpClient
      .get<FeedbackResponse>(
        `${this.apiUrl}/report/feedback?pageNum=${pageNum}&pageSize=${pageSize}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
